import { Checkbox, Col, Input, Row } from 'antd';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';

type PropType = {
    className?: string;
    disabled?: boolean;
    items?: any;
    itemsWithInput?: any;
    itemsWithInputText?: any;
    label?: string;
    labelcheckbox?: string;
    name: string;
    onBlur: Function;
    onFocus: Function;
    placeholder?: string;
    setFieldValue: Function;
    setTouched: Function;
    value?: any;
    withError?: boolean;
};

type StateType = {
    checked?: boolean;
}

function onChange(e: any) {
}

const CheckboxField = (props: PropType, state: StateType) => (

    <AppContext.Consumer>
        {({ theme, locale }) => (
            <InputWrapper
                theme={theme}
                className={`goepik-component-padding form-input-wrapper_${props.name} ${props.className || ''}`}
            >
                {props.itemsWithInput &&
                    props.itemsWithInput.map((itemsWithInput: { value: string; label: string, labelcheckbox: string }) => (
                        <Row>
                            <Col sm={24} md={24} xl={24}>
                                <Checkbox
                                    key={`${itemsWithInput.value}`}
                                    // className={`goepik-component-padding `}
                                    onChange={onChange}
                                >
                                    {I18n.l(itemsWithInput.label || '')}
                                    <div>
                                        <Row>

                                            <Input
                                                name={props.name}
                                                // value={props.value}
                                                disabled={props.disabled}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    props.setFieldValue(props.name, e.target.value);
                                                    props.setTouched({ [props.name]: true });
                                                }}
                                                size="small"
                                                style={{ width: '15%', marginRight: '5px' }}
                                                placeholder={I18n.l(props.placeholder || '')} />
                                            {I18n.l(itemsWithInput.labelcheckbox || '')}

                                        </Row>
                                    </div>
                                </Checkbox>
                            </Col>
                        </Row>
                    ))}

                {props.items &&
                    props.items.map((item: any, index: number) => (
                        <Row key={index}>
                            <Col sm={24} md={24} xl={24}>
                                <Checkbox
                                    key={`${item.value}`}
                                    onChange={(e: any) => {
                                        props.setFieldValue(props.name, e.target.checked);
                                        props.setTouched({ [props.name]: true });
                                    }}
                                //defaultChecked={item.value}
                                >
                                    {I18n.l(item.label || '')}
                                </Checkbox>
                            </Col>
                        </Row>
                    ))}

                {props.itemsWithInputText &&
                    props.itemsWithInputText.map((itemsWithInputText: { value: string; label: string }, index: number) => (
                        <Row key={index}>
                            <Col sm={24} md={24} xl={24}>
                                <Checkbox
                                    key={`${itemsWithInputText.value}`}
                                    className={`goepik-component-padding }`}
                                    value={itemsWithInputText.value}

                                >
                                    {I18n.l(itemsWithInputText.label || '')}
                                    <Input
                                        style={{ width: '15%', marginLeft: '5px' }}
                                        name={props.name}
                                        // value={props.value}
                                        disabled={props.disabled}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            props.setFieldValue(props.name, e.target.value);
                                            props.setTouched({ [props.name]: true });
                                        }} /> {I18n.l('form.taskflowschedule.labels.daysbefore')}
                                </Checkbox>
                            </Col>
                        </Row>
                    ))}
            </InputWrapper>
        )}
    </AppContext.Consumer>
);

const InputWrapper = styled.div`
    width: 100%;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
`;

export default CheckboxField;
